import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=89e41764&scoped=true&"
import script from "./Dispatch.vue?vue&type=script&lang=js&"
export * from "./Dispatch.vue?vue&type=script&lang=js&"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=89e41764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e41764",
  null
  
)

export default component.exports